
import {Component, Vue} from "vue-property-decorator";
import AnonymousLayout from "@/layouts/AnonymousLayout.vue";
import {Variables} from "../../../variables";

@Component({
  components: {AnonymousLayout}
})
export default class Redirect extends Vue {
  get action() {
    return Variables.ApiBaseUrl + '/api/Access/Redirect'
  }
}
